/**
 *
 */

var Product = (function($) {
  function initProductSwatches() {
    const $form = $(".variations_form");
    const $select = $("#pa_talla");

    if (!$form.length || !$select.length) return;

    // Datos de variaciones que WooCommerce incluye en el formulario
    const variations = $form.data("product_variations");

    // Crear selector custom
    const $sizeSelector = $("<div>", {
      class: "product-size-selector"
    });

    // Ordenamos numéricamente las tallas
    const options = $select
      .find('option[value!=""]')
      .get()
      .sort(function(a, b) {
        return parseFloat(a.value) - parseFloat(b.value);
      });

    $.each(options, function() {
      const $option = $(this);

      const $button = $("<button>", {
        type: "button",
        class: "product-size-selector__item",
        text: $option.text(),
        "data-value": $option.val()
      });

      $sizeSelector.append($button);
    });

    $select.after($sizeSelector);

    /**
     * Comprobar si una talla tiene una variación disponible
     */
    function sizeIsAvailable(value) {
      // Fallback por si WooCommerce no ha cargado
      // los datos completos de variaciones.
      if (!Array.isArray(variations)) {
        const $option = $select.find("option").filter(function() {
          return $(this).val() === value;
        });

        return !$option.prop("disabled");
      }

      return variations.some(function(variation) {
        return (
          variation.attributes.attribute_pa_talla === value &&
          variation.variation_is_active &&
          variation.is_in_stock
        );
      });
    }

    /**
     * Click en talla
     */
    $sizeSelector.on("click", ".product-size-selector__item", function() {
      const $button = $(this);

      if ($button.prop("disabled")) return;

      $select.val($button.data("value").toString()).trigger("change");
    });

    /**
     * Sincronizar UI con WooCommerce
     */
    function updateSizeSelector() {
      $sizeSelector.find(".product-size-selector__item").each(function() {
        const $button = $(this);
        const value = $button.data("value").toString();

        const available = sizeIsAvailable(value);

        // Active
        $button.toggleClass(
          "product-size-selector__item--active",
          available && $select.val() === value
        );

        // Disabled
        $button
          .prop("disabled", !available)
          .toggleClass("product-size-selector__item--disabled", !available);
      });
    }

    /**
     * Cambio normal del select
     */
    $select.on("change", updateSizeSelector);

    /**
     * Cuando WooCommerce recalcula variaciones
     */
    $form.on("woocommerce_update_variation_values", updateSizeSelector);

    /**
     * Cuando encuentra una variación
     */
    $form.on("found_variation", updateSizeSelector);

    /**
     * Reset variations
     */
    $form.on("reset_data", updateSizeSelector);

    // Estado inicial
    updateSizeSelector();
  }

  function initProductInfoAccordion() {
    const $accordion = $(".product-info");

    if (!$accordion.length) return;

    $accordion.on("click", ".product-info__trigger", function() {
      const $trigger = $(this);
      const $item = $trigger.closest(".product-info__item");
      const $content = $item.find(".product-info__content");

      const isOpen = $item.hasClass("product-info__item--active");

      // Cerramos el resto
      $accordion
        .find(".product-info__item")
        .removeClass("product-info__item--active")
        .find(".product-info__trigger")
        .attr("aria-expanded", "false");

      $accordion
        .find(".product-info__content")
        .stop(true, true)
        .slideUp(250);

      // Abrimos el seleccionado si estaba cerrado
      if (!isOpen) {
        $item.addClass("product-info__item--active");

        $trigger.attr("aria-expanded", "true");

        $content.stop(true, true).slideDown(250);
      }
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".single-product").length) {
      return;
    }

    initProductSwatches();
    initProductInfoAccordion();

    var $el = $(".product-summary");

    while ($el.length) {
      var styles = window.getComputedStyle($el[0]);

      console.log(
        $el[0],
        "overflow:",
        styles.overflow,
        "overflowX:",
        styles.overflowX,
        "overflowY:",
        styles.overflowY,
        "transform:",
        styles.transform,
        "filter:",
        styles.filter,
        "contain:",
        styles.contain
      );

      $el = $el.parent();
    }
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Product.init);
